import * as bootstrap from "bootstrap"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="carousel"
export default class extends Controller {
  connect() {
    console.log(this.element)

    const carousel = new bootstrap.Carousel(this.element, {
      interval: 2000,
      touch: false
    })
  }
}
